import { KeyboardEventHandler } from "react";

import { useGlobalNewOpportunityModalContext } from "../context";
import { useGlobalCreateOpportunityStore } from "../store";

export const useInputKeyDown = () => {
  const { form } = useGlobalNewOpportunityModalContext();
  const setIsSaveAndNewMode = useGlobalCreateOpportunityStore(
    state => state.setIsSaveAndNewMode,
  );

  const handleKeyDown: KeyboardEventHandler = e => {
    const isMetaEnterKey = e.metaKey && e.key === "Enter";

    if (isMetaEnterKey) {
      e.preventDefault();
      setIsSaveAndNewMode(false);
      form?.submit();
    }
  };

  return { handleKeyDown };
};
